import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Deposit from "@/pages/Deposit";

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Deposit />} />
            <Route path="/deposit" element={<Deposit />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
